<template lang="pug">
  .component-backoffice-transactions(v-if="item")
    .card(v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="6")
          div(slot="actionBullets")
            //dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              transaction-action-buttons(:transaction="item")
          transaction-fields(:item="item", :fieldName="'transaction-id'", slot="n1")
          transaction-fields(:item="item", :fieldName="'transaction-date'", slot="n1")
          transaction-fields(:item="item", :fieldName="'transaction-client'", slot="n2")
          transaction-fields(:item="item", :fieldName="'transaction-payment-method'", slot="n3")
          transaction-fields(:item="item", :fieldName="'invoice-link'", slot="n4")
          transaction-fields(:item="item", :fieldName="'transaction-amount'", slot="n5")
          transaction-fields(:item="item", :fieldName="'transaction-status'", slot="n6")
          transaction-fields(:item="item", :fieldName="'transaction-date'", slot="n7")

          div(slot="actionPage")
            router-link(:to="{name:'transaction', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .one-look(v-if="$is('oneLook')")
      router-link(:to="{name:'transaction', params:{id:item.id}}") TR{{item.id}}
    .card(v-if="$is('client-list')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="5")
          transaction-fields(:item="item", :fieldName="'transaction-id'", slot="n1")
          transaction-fields(:item="item", :fieldName="'transaction-date'", slot="n1")
          transaction-fields(:item="item", :fieldName="'transaction-payment-method'", slot="n2")
          transaction-fields(:item="item", :fieldName="'invoice-link'", slot="n3")
          transaction-fields(:item="item", :fieldName="'transaction-amount'", slot="n4")
          transaction-fields(:item="item", :fieldName="'transaction-status'", slot="n5")
          div(slot="actionPage")
            router-link(:to="{name:'transaction', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .detail(v-if="$is('detail')")
      .row
        .column.card.mr-4.p-2
          .row
            .column
              h2 Transaction
              div TR{{item.id}} &nbsp;
                strong {{item.status}}
                br
                small {{item.response.message}}

              div Gateway id &nbsp;
                a(v-on:click="viewOnGateway") {{item.transaction_uid}}
              .field(:style="item.amount < 0 ? 'color:#cc4b37':''") {{$priceWithcurrency(item.amount.toFixed(2))}}
            .column
              h2 Client
              router-link(:to="{name:'client', params:{id:item.client_id}}" )
                span(v-if="item.client_organization_name" ) {{item.client_organization_name}}
                span(v-else) {{item.name}} {{item.surname}}
        .column.card.mr-4.p-2
          .row
            .column
              h2 Invoice
              router-link(v-if="item.invoice.id", :to="{name:'invoice', params:{id:item.invoice.id}}" )
                span {{item.invoice.type}}{{item.invoice_internal_id}} ({{item.invoice_id}})
            .column
              h2 Payment Method
              span PM{{item.payment_method_id}} {{item.payment_name}}
              div {{item.payment_method_provider}}
      .row
        .columns.card.mr-4.p-2
          .inner-content
            h2 Raw response
            pre(v-for="(value,key) in getResponse" ) {{key}} : {{value}}
</template>
<script type="text/babel">
import StatisticsCard5 from "components/structure/ui/StatisticsCard5";
import CardN from "components/structure/CardN";
import TransactionActionButtons from "../structure/ui/actions/TransactionButtons";
import Dropdown from "../structure/foundation/Dropdown";
import GatewayUrlHelper from "../../lib/helpers/gatewayUrlHelper";
import StatisticsCard6 from "../structure/ui/StatisticsCard6.vue";
import StatisticsCard7 from "../structure/ui/StatisticsCard7.vue";
import TransactionFields from "../structure/ui/entity-fields/TransactionFields.vue";

export default {
  name: "Transaction",
  components: {
    TransactionFields,
    StatisticsCard7,
    StatisticsCard6,
    Dropdown,
    TransactionActionButtons,
    CardN,
    StatisticsCard5,
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    viewOnGateway() {
      var url = GatewayUrlHelper.transactionUrl(this.item.payment_method_provider, this.item.transaction_uid);
      window.open(url, '_blank')
    }
  },
  computed: {
    getResponse() {
      return JSON.stringify(this.item.response.raw).startsWith("{", 0) ? this.item.response.raw : {"message": this.item.response.raw}
    }
  },
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-backoffice-transactions
  .raw
    pre
      font-family: monospace
</style>



// WEBPACK FOOTER //
// Transaction.vue?7dd36048